export const initialState = {
  showViewer: false,
  url: null,
  name: '',
};

const state = () => ({ ...initialState });

export default state();
